export default __webpack_public_path__ + "static/media/roztocza.8a8103f7.svg";